import fetch from './../fetch';

const querySearch = (keywords) => {
    return fetch.post(`teacher/teaching/quality/collect/query?pageNum=${keywords.pageNum}&pageSize=${keywords.pageSize}&order=${keywords.order || ''}&sort=${keywords.sort || ''}`, keywords)
        .then(res => {
            if (res.code === 200) {
                const data = res.payload.data;
                return {
                    data: res.payload.data,
                    termData: res.payload.meta.extParams.termData
                }
            }
        })
}


export default {
    querySearch
}